import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'

var userDataSelector = '#current_user_data';

// Set proper headers for ajax requests
$.ajaxSetup({
  'beforeSend': function(xhr) {
    xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
  }
});

Object.assign(window.SOPHIA, {
  loggedIn: function() {
    return !!this.currentUserId();
  },

  currentUserId: function() {
    return $(userDataSelector).data('id');
  },

  currentUserSlug: function() {
    return $(userDataSelector).data('slug');
  }
});

$(window).on('load', () => {
  const currentUserInfo = {
    id: $(userDataSelector).data('id'),
    isMember: $(userDataSelector).data('isMember') !== undefined,
    wasMember: $(userDataSelector).data('wasMember') !== undefined
  }

  localStorage.setItem('currentUserInfo', JSON.stringify(currentUserInfo))
})

_.extend(window.SOPHIA, Backbone.Events);
